import { useStepperContext } from "./StepperContext"

type Props = React.PropsWithChildren<{ index: number }>

export default function StepperSection({ children, index }: Props) {
  const { activeStep } = useStepperContext()

  if (index === activeStep) {
    return <>{children}</>
  }

  return <></>
}
